module.exports = __webpack_public_path__ + "img/header-content-image.f0ef47dd.svg";